<script lang="ts">
	import Fa from 'svelte-fa';
	import type { IconDefinition } from '@fortawesome/free-solid-svg-icons';
	import SideRailAnchor from '$components/SideRailAnchor.svelte';
	import { closeDrawer } from '$lib/shared/lib/drawerStore';

	interface Props {
		selectedPath: string | null;
		icon: IconDefinition;
		title: string;
		path: string;
		collapsed?: boolean;
	}

	let { selectedPath, icon, title, path, collapsed = false }: Props = $props();
</script>

<SideRailAnchor href="/admin/{path}" selected={selectedPath === path} onclose={closeDrawer}>
	{#snippet lead()}
		<div class="flex {collapsed ? 'justify-center' : 'space-x-4'}">
			<div class="mt-1 justify-center"><Fa {icon} /></div>
			{#if !collapsed}
				<div>{title}</div>
			{/if}
		</div>
	{/snippet}
</SideRailAnchor>
